<template>
  <the-tab-recent-basic-chart :latestTime="this.chartData[this.chartData.length - 1][0]" v-model="selectedTimeRange" :loading="loading" :options="options" />
</template>

<script>
import TheTabRecentBasicChart from '@/components/pages/station/TheTabRecentBasicChart'
export default {
  name: 'TheTabRecentSoilMoistureChart',
  props: {
    records: {
      type: Array
    }
  },
  components: { TheTabRecentBasicChart },
  computed: {
    chartData () {
      const output = this.records.slice(this.records.length - this.selectedTimeRange).map((item) => {
        return [item.TmStamp.date, this._.round(item.TSoil_4in_Avg, 1)]
      })
      output.unshift(['time', 'Soil Moisture'])
      return output
    },
    options () {
      return {
        grid: {
          x2: '5%'
        },
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.chartData
        },
        axisPointer: {
          link: { xAxisIndex: 'all' }
        },
        yAxis: [
          {
            type: 'value',
            name: 'Soil Moisture (m³/m³)',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        xAxis: [
          {
            type: 'time'
          },
          {
            gridIndex: 1,
            type: 'time',
            show: false
          }
        ],
        series: [

          {
            name: 'Soil Moisture',
            type: 'line',
            encode: {
              y: 1
            }
          }
        ]
      }
    }
  },
  data () {
    return {
      loading: false,
      selectedTimeRange: 168
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
